export enum IUserTypes {
    Administrator = 0,
    SalesAgent = 1,
    LoadingAgent = 2,
    Driver = 3,
    Customer = 4,
    All=-1,
    AllExceptCustomer=-2
}
